import React from 'react';
import classNames from 'classnames';
import { useHistory } from 'react-router-dom';

import { JourneyTemplateForm } from 'src/dashboard/home/forms/journey-template-form';
import { useNotificationMessage } from 'src/common/notification/message.hook';
import { useCurrentOrganization } from 'src/store/organization';
import useDashboardStore from 'src/dashboard/store/dashboard';
import { useSlideOverStore } from 'src/store/slide-over';
import { useFeatureRestrictions } from 'src/hooks/useFeatureRestrictions';
import { FreeGatingEnum, useFreeGatingStore } from 'src/common/free-gating/store';
import SlideOver from 'src/common/components/slide-over';

/**
 *
 * @deprecated
 */
export const JourneyTemplateSlideover = () => {
  const { currentOrganization } = useCurrentOrganization();
  const { templateJourney, onJourneyCreateTemplateClose } = useDashboardStore();
  const closeSlideOver = useSlideOverStore((state) => state.closeSlideOver);
  const { setSuccessNotification } = useNotificationMessage();
  const history = useHistory();
  const { features, showUpgradeModal } = useFeatureRestrictions();
  const setFreeGatingModalByType = useFreeGatingStore((state) => state.setFreeGatingModalByType);

  const onClose = () => {
    closeSlideOver();
    onJourneyCreateTemplateClose();
  };

  // Check if user has access to organization templates
  if (templateJourney && !features.canAccessOrganizationTemplates) {
    setFreeGatingModalByType(FreeGatingEnum.ORG_TEMPLATES, true);
    onClose();
    return null;
  }

  const onJourneyTemplateCreateSuccess = () => {
    onClose();
    history.push(`/${currentOrganization.slug}/library/organization-templates`);
    setSuccessNotification('Created the template successfully');
  };

  return (
    <SlideOver
      type='template'
      open={Boolean(templateJourney)}
      onClose={onClose}
      title={`Create new Template`}
      maxWidth='auto'
      panelClassName={classNames('w-[368px]')}
    >
      <JourneyTemplateForm journey={templateJourney} onSuccess={onJourneyTemplateCreateSuccess} />
    </SlideOver>
  );
};
